import { API_NAME, REDUX_STORE } from '@funnels/constants';
import {
  BrokerInterviewsGuarantorActionTypes,
  BrokerInterviewsGuarantorReducerState,
  SharedActionTypes,
} from '@funnels/types';

const initialState: BrokerInterviewsGuarantorReducerState = {
  data: [],
  error: null,
  loading: 0,
};

export default function brokerInterviewsGuarantorReducer(
  state: BrokerInterviewsGuarantorReducerState = initialState,
  action: BrokerInterviewsGuarantorActionTypes | SharedActionTypes
): BrokerInterviewsGuarantorReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
      return {
        ...state,
        data: [],
      };

    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.CLEAR_BROKER_INTERVIEWS_GUARANTOR_ERROR:
      return {
        ...state,
        error: null,
      };

    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.DELETE_BROKER_INTERVIEWS_GUARANTOR:
    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_BROKER_INTERVIEWS_GUARANTOR:
    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_ALL_BROKER_INTERVIEWS_GUARANTOR:
    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS_GUARANTOR:
      return {
        ...state,
        loading: state.loading + 1,
      };

    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_BROKER_INTERVIEWS_GUARANTOR_SUCCESS:
      const { brokerInterviewsGuarantor: serverData } = action;

      const { data, ...rest } = state;
      const newData = data.length
        ? data.map((storeItem) => (storeItem.applicantId === serverData.applicantId ? serverData : storeItem)) // to keep the order/index unchanged
        : [serverData];

      return {
        ...rest,
        data: [...newData],
        loading: state.loading - 1,
      };

    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_ALL_BROKER_INTERVIEWS_GUARANTOR_SUCCESS:
      const { brokerInterviewsGuarantorList: serverDataAll } = action;

      return {
        ...state,
        data: [...serverDataAll],
        loading: state.loading - 1,
      };

    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.DELETE_BROKER_INTERVIEWS_GUARANTOR_SUCCESS: {
      const { applicantId } = action;
      const { data, ...rest } = state;
      const newData = data.filter((storeItem) => storeItem.applicantId !== applicantId);

      return {
        ...rest,
        data: [...newData],
        loading: state.loading - 1,
      };
    }

    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS_GUARANTOR_SUCCESS:
      const { brokerInterviewsGuarantorList } = action;
      return {
        ...state,
        data: brokerInterviewsGuarantorList,
        loading: state.loading - 1,
      };

    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS_GUARANTOR_FAIL:
    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.DELETE_BROKER_INTERVIEWS_GUARANTOR_FAIL:
    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_BROKER_INTERVIEWS_GUARANTOR_FAIL:
    case REDUX_STORE.BROKER_INTERVIEWS_GUARANTOR.ACTION_TYPES.FETCH_ALL_BROKER_INTERVIEWS_GUARANTOR_FAIL:
      return {
        ...state,
        error: {
          name: API_NAME.BROKER_INTERVIEWS_GUARANTOR,
          message: action.message,
        },
        loading: state.loading - 1,
      };
    default:
      return state;
  }
}
